import './BigNav.scss';
import Component from './BigNav.js';
export default Component;
